var React = require('react');

function Flag (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9 2L4 4.14286V2H2V18.241C2 18.2413 2 18.2407 2 18.241V22H4V18.1426L9 16L15 19L22 16V2.759C22.0001 2.67622 21.9796 2.59471 21.9404 2.5218C21.9012 2.44888 21.8445 2.38684 21.7754 2.34124C21.7063 2.29565 21.627 2.26792 21.5445 2.26054C21.4621 2.25317 21.3791 2.26638 21.303 2.299L15 5L9 2ZM4 15.967L9.065 13.797L15.065 16.797L20 14.68V5.033L14.935 7.204L8.935 4.204L4 6.319V15.967Z","fill":"currentColor"}));
}

Flag.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Flag;

Flag.default = Flag;
